type EnvironmentConfig = {
    PUBLIC_URL: string;
    REACT_APP_OKTA_PATH: string;
    REACT_APP_OKTA_CLIENT_ID: string;
    SHOW_UPDATE_POPUP: boolean;
    FEATURE_FLAG_COLLECT_EMAILS: boolean;
    FEATURE_FLAG_BARCODE_SCANNING: boolean;
    FEATURE_FLAG_VERIFY_POP_UP: boolean;
    REACT_APP_LOAD_MANAGER_SERVICE: string;
    REACT_APP_DISPATCH_SERVICE: string;
    REACT_APP_FILE_SERVICE: string;
    REACT_APP_DYNAMAN_API: string;
    REACT_APP_APP_INSIGHTS_KEY: string;
    REACT_APP_ENVIRONMENT: string;
    REACT_APP_APIM_KEY: string;
    REACT_APP_COSMOS_ENDPOINT: string;
    QUANTITY_LIMIT_FOR_DISCREPANCY: number
};

const environments: Record<string, EnvironmentConfig> = {
    LOCAL: {
        PUBLIC_URL: "localhost,127.0.0.1",
        REACT_APP_OKTA_PATH: "https://dotfoods.okta.com",
        REACT_APP_OKTA_CLIENT_ID: "0oapzhu1enQh2AC7e0x7",
        SHOW_UPDATE_POPUP: false,
        FEATURE_FLAG_COLLECT_EMAILS: true,
        FEATURE_FLAG_BARCODE_SCANNING: true,
        FEATURE_FLAG_VERIFY_POP_UP: true,
        REACT_APP_LOAD_MANAGER_SERVICE: "http://localhost:3001/api",
        REACT_APP_DISPATCH_SERVICE: "https://api-dev-exp.dotfoods.com/dti/domainservices/dispatch/api",
        REACT_APP_FILE_SERVICE: "http://localhost:3001/api",
        REACT_APP_DYNAMAN_API: "http://localhost:3001/api",
        REACT_APP_APP_INSIGHTS_KEY: "fdf12817-c3de-4c84-9ae9-02a229a99b3c",
        REACT_APP_ENVIRONMENT: "LOCAL",
        REACT_APP_APIM_KEY: "8b97d0881d0b466c806e96c9f08e107a",
        REACT_APP_COSMOS_ENDPOINT: "https://func-cosmos-dti-dev.azurewebsites.net/api",
        QUANTITY_LIMIT_FOR_DISCREPANCY: 10
    },
    DEV: {
        PUBLIC_URL: "app-loadmanager-client-dev.azurewebsites.net",
        REACT_APP_OKTA_PATH: "https://dotfoods.okta.com",
        REACT_APP_OKTA_CLIENT_ID: "0oapzhu1enQh2AC7e0x7",
        SHOW_UPDATE_POPUP: true,
        FEATURE_FLAG_COLLECT_EMAILS: true,
        FEATURE_FLAG_BARCODE_SCANNING: true,
        FEATURE_FLAG_VERIFY_POP_UP: true,
        REACT_APP_LOAD_MANAGER_SERVICE: "https://api-dev-exp.dotfoods.com/dti/domainservices/loadmanager/api",
        REACT_APP_DISPATCH_SERVICE: "https://api-dev-exp.dotfoods.com/dti/domainservices/dispatch/api",
        REACT_APP_FILE_SERVICE: "https://func-files-dti-dev.azurewebsites.net/api",
        REACT_APP_DYNAMAN_API: "https://dotwhdynamanapi-dev.dotfoods.com/api",
        REACT_APP_APP_INSIGHTS_KEY: "fdf12817-c3de-4c84-9ae9-02a229a99b3c",
        REACT_APP_ENVIRONMENT: "DEV",
        REACT_APP_APIM_KEY: "8b97d0881d0b466c806e96c9f08e107a",
        REACT_APP_COSMOS_ENDPOINT: "https://func-cosmos-dti-dev.azurewebsites.net/api",
        QUANTITY_LIMIT_FOR_DISCREPANCY: 10
    },
    TEST: {
        PUBLIC_URL: "app-loadmanager-client-qa.azurewebsites.net",
        REACT_APP_OKTA_PATH: "https://dotfoods.okta.com",
        REACT_APP_OKTA_CLIENT_ID: "0oapzhu1enQh2AC7e0x7",
        SHOW_UPDATE_POPUP: true,
        FEATURE_FLAG_COLLECT_EMAILS: true,
        FEATURE_FLAG_BARCODE_SCANNING: false,
        FEATURE_FLAG_VERIFY_POP_UP: true,
        REACT_APP_LOAD_MANAGER_SERVICE: "https://api-qa-exp.dotfoods.com/dti/domainservices/loadmanager/api",
        REACT_APP_DISPATCH_SERVICE: "https://api-qa-exp.dotfoods.com/dti/domainservices/dispatch/api",
        REACT_APP_FILE_SERVICE: "https://func-files-dti-qa.azurewebsites.net/api",
        REACT_APP_DYNAMAN_API: "https://dti-gate-station.azurewebsites.net/api",
        REACT_APP_APP_INSIGHTS_KEY: "aecedf29-6af0-420f-9579-ab9af151a24a",
        REACT_APP_ENVIRONMENT: "TEST",
        REACT_APP_APIM_KEY: "fe5046ddd06d434da639eb6c8c684163",
        REACT_APP_COSMOS_ENDPOINT: "https://func-cosmos-dti-qa.azurewebsites.net/api",
        QUANTITY_LIMIT_FOR_DISCREPANCY: 10
    },
    UAT: {
        PUBLIC_URL: "app-loadmanager-client-uat.azurewebsites.net",
        REACT_APP_OKTA_PATH: "https://dotfoods.okta.com",
        REACT_APP_OKTA_CLIENT_ID: "0oapzhu1enQh2AC7e0x7",
        SHOW_UPDATE_POPUP: true,
        FEATURE_FLAG_COLLECT_EMAILS: true,
        FEATURE_FLAG_BARCODE_SCANNING: false,
        FEATURE_FLAG_VERIFY_POP_UP: true,
        REACT_APP_LOAD_MANAGER_SERVICE: "https://api-uat-exp.dotfoods.com/dti/domainservices/loadmanager/api",
        REACT_APP_DISPATCH_SERVICE: "https://api-uat-exp.dotfoods.com/dti/domainservices/dispatch/api",
        REACT_APP_FILE_SERVICE: "https://func-files-dti-uat.azurewebsites.net/api",
        REACT_APP_DYNAMAN_API: "https://dti-gate-station.azurewebsites.net/api",
        REACT_APP_APP_INSIGHTS_KEY: "83f165f4-a2f2-4fff-80ea-f0f9853b037b",
        REACT_APP_ENVIRONMENT: "UAT",
        REACT_APP_APIM_KEY: "eaae1ea5a2cd4c90aed894b1b89fbd37",
        REACT_APP_COSMOS_ENDPOINT: "https://func-cosmos-new-dti-prod.azurewebsites.net/api",
        QUANTITY_LIMIT_FOR_DISCREPANCY: 10
    },
    PROD: {
        PUBLIC_URL: "app-loadmanager-service.azurewebsites.net,loadmanager.dotfoods.com",
        REACT_APP_OKTA_PATH: "https://dotfoods.okta.com",
        REACT_APP_OKTA_CLIENT_ID: "0oapzhu1enQh2AC7e0x7",
        SHOW_UPDATE_POPUP: true,
        FEATURE_FLAG_COLLECT_EMAILS: true,
        FEATURE_FLAG_BARCODE_SCANNING: false,
        FEATURE_FLAG_VERIFY_POP_UP: true,
        REACT_APP_LOAD_MANAGER_SERVICE: "https://api-prod.dotfoods.com/dti/domainservices/loadmanager/api",
        REACT_APP_DISPATCH_SERVICE: "https://api-prod.dotfoods.com/dti/domainservices/dispatch/api",
        REACT_APP_FILE_SERVICE: "https://func-files-new-dti-prod.azurewebsites.net/api",
        REACT_APP_DYNAMAN_API: "https://dti-gate-station-prd.azurewebsites.net/api",
        REACT_APP_APP_INSIGHTS_KEY: "eb1880fb-02d8-45d9-a1c0-a21e737ce1f9",
        REACT_APP_ENVIRONMENT: "PROD",
        REACT_APP_APIM_KEY: "e71abcb669864a3ba567e087723c3dd2",
        REACT_APP_COSMOS_ENDPOINT: "https://func-cosmos-new-dti-prod.azurewebsites.net/api",
        QUANTITY_LIMIT_FOR_DISCREPANCY: 10
    }
};

export function envConfig(): EnvironmentConfig {
    let env = process.env.REACT_APP_ENVIRONMENT;

    if (env && environments[env]) {
        return environments[env];
    }

    // Fallback to URL-based detection if needed...
    if (typeof window !== 'undefined' && window.location && window.location.hostname) {
        const hostname = window.location.hostname.toLowerCase();
        const envOrder = ["LOCAL", "DEV", "TEST", "UAT", "PROD"];
        for (const key of envOrder) {
            const dynamicEnv = environments[key];
            const hostTokens = dynamicEnv.PUBLIC_URL.split(',').map(token => token.trim().toLowerCase());
            if (hostTokens.some(token => hostname === token || hostname.includes(token))) {
                return dynamicEnv;
            }
        }
    }

    return environments.LOCAL;
}
